import React, { memo } from 'react';
import PropTypes from 'prop-types';

import EmailProps from '../../proptypes/email';
import UpdateEmailButton from '../UpdateEmailButton';

const EmailRow = ({ email, style }) => (
  <div className={style.rowContainer}>
    <div className={style.rowContent}>
      <p data-testid="overview-email">{email.address}</p>
    </div>
    <div className={style.editButton}>
      <UpdateEmailButton email={email} />
    </div>
  </div>
);

EmailRow.propTypes = {
  email: EmailProps.isRequired,
  style: PropTypes.shape({
    rowContainer: PropTypes.string,
    rowContent: PropTypes.string,
    editButton: PropTypes.string,
  }).isRequired,
};

export default memo(EmailRow);
